<template>
  <div @click.stop.prevent class="shape-component" :style="getTextStyle">
    <cxIcon v-if="options.iconSrc && options.iconSrc.length" :options="options" :iconStyle="getIconStyle"></cxIcon>
    <svg
      v-else
      width="100%"
      height="100%"
      :viewBox="viewBox"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <path
        v-for="(item, index) in pathD"
        :key="index"
        :d="item"
        :fill="shapeUrl[index]"
        :stroke="svgBorder[index]"
        stroke-width="1%"
      />
      <defs>
        <linearGradient
          v-for="(linearItem, linearIndex) in linearGradient"
          :key="linearIndex"
          :id="linearItem"
          :x1="linearGradientX1[linearIndex]"
          :y1="linearGradientY1[linearIndex]"
          :x2="linearGradientX2[linearIndex]"
          :y2="linearGradientY2[linearIndex]"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            v-for="(colorItem, colorIndex) in shapeColor[linearIndex].colorStops"
            :key="colorIndex"
            :offset="colorItem.offset"
            :stop-color="colorItem.color"
          />
        </linearGradient>
        <linearGradient
          v-for="(linearItem, linearIndex) in borderLinearGradient"
          :key="linearIndex + 4"
          :id="linearItem"
          :x1="linearGradientX1[linearIndex]"
          :y1="linearGradientY1[linearIndex]"
          :x2="linearGradientX2[linearIndex]"
          :y2="linearGradientY2[linearIndex]"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            v-for="(colorItem, colorIndex) in shapeBorderColor[linearIndex].colorStops"
            :key="colorIndex + 4"
            :offset="colorItem.offset"
            :stop-color="colorItem.color"
          />
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
import { isSsrPage } from "utils"
export default {
  mixins: [eventMixin],
  name: "cxshape",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  computed: {
    themeColor() {
      return isSsrPage() ? this.$store.state.page.themeColor : this.$store.state[this.request_prefix].page.themeColor
    },
    getIconStyle() {
      return {
        display: "inline-block",
        "--color": this.$parseColor(this.options.iconColor, {
          isThemeColor: this.options.iconColorIsThemeColor
        }),
        width: this.options.width + "px",
        height: this.options.height + "px"
      }
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      if (!this.options.background || !Array.isArray(this.options.background)) {
        return {}
      }
      this.options.background.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    boxShadowStyle() {
      let tmpStyle = ""
      if (
        Array.isArray(this.options.boxShadowH) &&
        Array.isArray(this.options.boxShadowV) &&
        Array.isArray(this.options.boxShadowBlur) &&
        Array.isArray(this.options.boxShadowSpread) &&
        Array.isArray(this.options.boxShadowColor)
      ) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) tmpStyle += ","
          tmpStyle += `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.$parseColor(this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getTextStyle() {
      return {
        ...this.bgStyle,
        // width: this.options.skew != 0 ? parseInt(this.options.width / 2) + "px" : this.options.width + "px",
        // height: this.options.height + "px",
        "border-style": this.options.borderStyle,
        "border-color": this.$parseColor(this.options.borderColor),
        "border-width": this.options.borderChecked ? this.options.borderWidth + "px" : "0px",
        "border-top-left-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderTopLeftRadius + "px",
        "border-top-right-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderBottomRightRadius + "px",
        "clip-path": this.options.shapeType === "clip" ? this.options.clipPath : "",
        transform: "rotate(" + this.options.rotate + "deg) skew(" + this.options.skew + "deg)",
        "margin-left": -this.options.skew + "%",
        opacity: this.options.opacity / 100,
        "box-shadow": this.boxShadowStyle
      }
    },
    viewBox() {
      return this.options && this.options.viewBox ? this.options.viewBox : "0 0 44 44"
    },
    pathD() {
      return this.options && this.options.pathD ? this.options.pathD : ""
    },
    shapeUrl() {
      let shapeUrl = []
      if (this.linearGradient && Array.isArray(this.linearGradient)) {
        this.linearGradient.forEach((item, index) => {
          shapeUrl.push(`url(#${item})`)
        })
      }
      return shapeUrl
    },
    linearGradient() {
      let linearGradient = []
      if (this.options && this.options.linearGradient && Array.isArray(this.options.linearGradient)) {
        this.options.linearGradient.forEach((item, index) => {
          let _id = item + this.myid.rect_id
          if (this.myid.uid !== null && typeof this.myid.uid !== "undefined") {
            _id += this.myid.uid
          }
          if (this.myid.container_id !== null && typeof this.myid.container_id !== "undefined") {
            _id += this.myid.container_id
          }
          linearGradient.push(_id)
        })
      }
      return linearGradient
    },
    svgBorder() {
      let shapeUrl = []
      if (this.borderLinearGradient && Array.isArray(this.borderLinearGradient)) {
        this.borderLinearGradient.forEach((item, index) => {
          shapeUrl.push(`url(#${item})`)
        })
      }
      return shapeUrl
    },
    borderLinearGradient() {
      let linearGradient = []
      if (this.options && this.options.borderLinearGradient && Array.isArray(this.options.borderLinearGradient)) {
        this.options.borderLinearGradient.forEach((item, index) => {
          linearGradient.push(item + this.myid.rect_id)
        })
      }
      return linearGradient
    },
    width() {
      return this.options.skew != 0 ? parseInt(this.options.width / 2) : this.options.width
    },
    height() {
      return this.options.height
    },
    bgAngleValue() {
      return this.options && this.options.bgAngleValue ? this.options.bgAngleValue : ["0°"]
    },
    linearGradientX1() {
      let linearGradientX1 = []
      if (this.options && this.options.bgAngleValue && Array.isArray(this.options.bgAngleValue)) {
        this.options.bgAngleValue.forEach((item, index) => {
          if (item === "0°") linearGradientX1.push(0)
          if (item === "45°") linearGradientX1.push(0)
          if (item === "90°") linearGradientX1.push("50%")
        })
      }
      return linearGradientX1
    },
    linearGradientY1() {
      let linearGradientY1 = []
      if (this.options && this.options.bgAngleValue && Array.isArray(this.options.bgAngleValue)) {
        this.options.bgAngleValue.forEach(item => {
          if (item === "0°") linearGradientY1.push("50%")
          if (item === "45°") linearGradientY1.push(0)
          if (item === "90°") linearGradientY1.push(0)
        })
      }
      return linearGradientY1
    },
    linearGradientX2() {
      let linearGradientX2 = []
      if (this.options && this.options.bgAngleValue && Array.isArray(this.options.bgAngleValue)) {
        this.options.bgAngleValue.forEach((item, index) => {
          if (item === "0°") linearGradientX2.push("100%")
          if (item === "45°") linearGradientX2.push("100%")
          if (item === "90°") linearGradientX2.push("50%")
        })
      }
      return linearGradientX2
    },
    linearGradientY2() {
      let linearGradientY2 = []
      if (this.options && this.options.bgAngleValue && Array.isArray(this.options.bgAngleValue)) {
        this.options.bgAngleValue.forEach((item, index) => {
          if (item === "0°") linearGradientY2.push("50%")
          if (item === "45°") linearGradientY2.push("100%")
          if (item === "90°") linearGradientY2.push("100%")
        })
      }
      return linearGradientY2
    },
    shapeColor() {
      return this.options && this.options.shapeColor ? this.options.shapeColor : []
    },
    shapeBorderColor() {
      return this.options && this.options.shapeBorderColor ? this.options.shapeBorderColor : []
    }
  },
  methods: {
    async updateData() {}
  }
}
</script>

<style scoped>
.shape-component {
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
}
</style>
